<template>
    <BlockContainer
        class="home-banner"
        align="center"
        justify="center"
        :style="`background-image: url(${getBanner});${getStyle}`"
    >
        <BlockContainer class="home-banner-content" align="center">
            <img class="home-logo" :src="bandIndexLogo" />
            <div v-if="title" class="home-title">{{ title }}</div>
        </BlockContainer>
    </BlockContainer>
</template>

<script setup lang="ts">
import { computed, inject, Ref } from 'vue';
import BlockContainer from './block-container.vue';
import { useStore } from 'vuex';

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    banner: {
        type: String,
        default: '',
    },
    logo: {
        type: String,
        default: '',
    },
    titleColor: {
        type: String,
        default: '#145190',
    },
});

const themeConfig = inject<Ref<any>>('themeConfig');

const store = useStore();

const getStyle = computed(() => {
    return `
        --home-banner-title-color: ${props.titleColor};
    `;
});

// 首页导航Logo
const bandIndexLogo = computed(
    () => props.logo || store.state.brand?.publishBrand?.brandConfig?.indexNavLogoUrl,
);

const getBanner = computed(() => {
    return props.banner || themeConfig?.value?.bannerUrl;
});
</script>

<style lang="scss" scoped>
.home-banner {
    min-width: 1200px;

    .home-banner-content {
        width: 1200px;
        height: 100px;
    }

    .home-logo {
        width: 254.53px;
        height: 57.31px;
    }

    .home-title {
        margin-left: 20px;
        color: var(--home-banner-title-color);
        font-size: 20px;
        font-weight: 600;
        white-space: pre-wrap;
    }
}
</style>
